(function(){
  "use strict";

  if (window.__PO_K5_TAXIELIS_TEXTS_20260303__) return;
  window.__PO_K5_TAXIELIS_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "taxielis";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim();
    if (s === "fr" || s === "en" || s === "es") return s;
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return normLang(v || "fr");
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{
      if (document && document.documentElement){
        document.documentElement.setAttribute("lang", l);
      }
    }catch(__e){}
    return l;
  }

  function getLang(){ return readStoredLang(); }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    return [];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){
      key = "meta:none";
    }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;

    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));

    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){
      return String(html);
    }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);

    return tpl.innerHTML;
  }


  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: ""
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function qs(root, sel){
    if (!root || !root.querySelector) return null;
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function qsa(root, sel){
    if (!root || !root.querySelectorAll) return [];
    try{ return Array.prototype.slice.call(root.querySelectorAll(sel) || []); }catch(e){ return []; }
  }

  function getRoots(){
    return qsa(document, ROOT_SEL);
  }

  function getDetailBlocks(root){
    return qsa(root, ".po-lex-details");
  }

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k5-taxielis-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k5-taxielis-audio-styles";
    style.textContent = [
      ".po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}",
      ".po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(0,0,0,.14);border-radius:999px;padding:6px 10px;font:inherit;font-weight:800;letter-spacing:.3px;background:rgba(0,0,0,.02);color:inherit;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;}",
      ".po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(31,122,58,.10);border-color:rgba(184,134,11,.55);}",
      ".po-audio-btn.is-active{border-color:rgba(184,134,11,.72);box-shadow:0 0 0 1px rgba(184,134,11,.18),0 8px 18px rgba(31,122,58,.10);background:rgba(0,0,0,.04);}",
      ".po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}",
      "@media (max-width:700px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = qs(root, ".po-lex-panel");
    if (panel){
      var generalWrap = qs(root, '.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap notranslate";
        generalWrap.setAttribute("translate", "no");
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general"));
        var meta = qs(root, ".po-axis-meta");
        var defShort = qs(root, '[data-po-slot="def_short"]');
        var firstDetail = qs(panel, ".po-lex-details");
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else{
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = qs(detail, ".po-lex-summary");
      if (!summary) continue;
      var btn = qs(summary, '.po-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }

    bindAudioButtons(root, lang);
    refreshAudioButtons(root, lang);
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([:;!?])/g, "$1").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root) return;
    qsa(root, ".po-axis-audio-wrap, .po-audio-btn, script, style").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = qs(root, "[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = qs(detail, ".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    try{ clone.open = true; }catch(e){}
    var summary = qs(clone, ".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var sentences = raw.match(/[^.!?…]+[.!?…]?/g) || [raw];
    var chunks = [];
    var current = "";
    for (var i=0;i<sentences.length;i++){
      var s = clampStr(sentences[i]).trim();
      if (!s) continue;
      if (!current){
        current = s;
      }else if ((current + " " + s).length <= 210){
        current += " " + s;
      }else{
        chunks.push(current);
        current = s;
      }
    }
    if (current) chunks.push(current);
    return chunks;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var target = normLang(lang);
    for (var i=0;i<voices.length;i++){
      var vlang = clampStr(voices[i].lang).toLowerCase();
      if (vlang.indexOf(target) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    getRoots().forEach(function(root){ refreshAudioButtons(root, getLang()); });
  }

  function refreshAudioButtons(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    qsa(root, ".po-audio-btn").forEach(function(btn){
      var role = btn.getAttribute("data-po-audio-role") || "detail";
      var idx = btn.getAttribute("data-po-audio-index") || "0";
      var key = (role === "general") ? "general" : ("detail:" + idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);
      btn.textContent = active ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.classList.toggle("is-active", !!active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function bindAudioButtons(root, lang){
    qsa(root, ".po-audio-btn").forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute("data-po-audio-role") || "detail";
        var idx = btn.getAttribute("data-po-audio-index") || "0";
        var key = (role === "general") ? "general" : ("detail:" + idx);
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, getLang());
          return;
        }
        startAudio(root, getLang(), key);
      });
    });
  }

  function openDetailForPlayback(detail){
    if (!detail) return;
    try{ if (typeof detail.open !== "undefined") detail.open = true; }catch(e){}
    try{ detail.setAttribute("open", "open"); }catch(_e){}
  }

  function buildUnits(root, key){
    var units = [];
    var details = getDetailBlocks(root);
    if (key === "general"){
      var intro = collectGeneralText(root);
      if (intro) units.push({ key:"general", node: root, text: intro });
      for (var i=0;i<details.length;i++){
        var txt = collectDetailText(details[i]);
        if (txt) units.push({ key:"detail:" + i, node: details[i], text: txt });
      }
      return units;
    }
    var start = parseInt(String(key).split(":")[1], 10);
    if (isNaN(start)) start = 0;
    for (var j=0;j<details.length;j++){
      if (j < start) continue;
      var dTxt = collectDetailText(details[j]);
      if (dTxt) units.push({ key:"detail:" + j, node: details[j], text: dTxt });
    }
    return units;
  }

  function speakNextChunk(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.chunks.length){
      speakNextUnit(lang);
      return;
    }
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      speakNextUnit(lang);
      return;
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    var voice = pickVoice(lang);
    if (voice) utter.voice = voice;
    utter.lang = normLang(lang) === "en" ? "en-US" : (normLang(lang) === "es" ? "es-ES" : "fr-FR");
    utter.onend = function(){ speakNextChunk(lang); };
    utter.onerror = function(){ speakNextChunk(lang); };

    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(lang); }
  }

  function speakNextUnit(lang){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit && unit.node && unit.node.tagName && unit.node.tagName.toLowerCase() === "details"){
      openDetailForPlayback(unit.node);
    }
    PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = -1;
    speakNextChunk(lang);
  }

  function startAudio(root, lang, key){
    if (!root){
      stopAudio();
      return;
    }
    if (!PO_AUDIO_SYNTH){
      refreshAudioButtons(root, lang);
      return;
    }
    try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = key;
    refreshAudioButtons(root, lang);
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    speakNextUnit(lang);
  }

  function initAudioEverywhere(lang){
    getRoots().forEach(function(root){
      ensureAudioButtons(root, lang || getLang());
      refreshAudioButtons(root, lang || getLang());
    });
  }

  if (PO_AUDIO_SYNTH && PO_AUDIO_SYNTH.onvoiceschanged !== undefined){
    PO_AUDIO_SYNTH.onvoiceschanged = function(){
      getRoots().forEach(function(root){ refreshAudioButtons(root, getLang()); });
    };
  }

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Taxielis_copie_2.png?v=1772886281";
  var IMG_ELEMENT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535";
  var IMG_TOTEM = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195";
  var IMG_FREQ_99 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_99.png?v=1773410839";

  var FALLBACK = {
    fr: {
      title: "Taxiêlîs",
      kicker:
        "Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs : nœuds synchrétiques de syntonie vibratoire — matrice de passage)",
      h_def: "Définition opérative",
      chips: ["Élément", "Totem", "Fréquence"],
      def_short:
        "Nœuds de passage et d’interconnexion : points d’articulation vivante où des lignes de syntonie se croisent, se condensent, puis se redistribuent en basculements de phase, reconfigurations de rythme et réorientations de circulation.",
      def_long:
        "Au sein de La Katûvýs, Taxiêlîs désigne des nœuds synchrétiques de syntonie vibratoire, dynamiques, transitoires et modulants, opérant comme points d’articulation vivante dans le champ énergétique du système. Ce sont des organes de passage, des points de couture et de traversée, où l’énergie se recompose au contact de régimes distincts.\n\n" +
        "Taxiêlîs se manifeste comme des zones d’interférences fertiles : plusieurs lignes de syntonie — tantôt convergentes, tantôt dissonantes — entrent en tension opérative et produisent une densité spécifique du champ. Il s’y forme une géométrie de friction, un resserrement de trajectoires, où les forces se rencontrent, s’éprouvent, s’ajustent, puis se redistribuent. Cette densification prépare des basculements de phase, des reconfigurations de rythme, des changements de régime, et des frictions transmutatives qui réorientent la dynamique globale.\n\n" +
        "Fonction circulatoire : Taxiêlîs apparaît dans les zones de croisement vibratoire lorsque plusieurs lignes de résonance se rencontrent, se superposent, s’entrelacent ou entrent en friction. La superposition engendre une intensité localisée, lisible comme nécessité de changement de régime : ralentissement, seuil, pivot, courbure, diffraction, reprise d’axe. Il peut amplifier fractalement un motif, ou au contraire décharger une surcharge par dissipation spiralée. Toujours, il rend franchissable une tension, praticable une bifurcation, habitable un changement de rythme.\n\n" +
        "Taxiêlîs demeure une entité unique et structurante, tandis que ses manifestations se déploient en une pluralité de formes ajustées à la pression du champ : transitoire, persistant, silencieux, résonant. Dans chaque cas, la tension devient ressource d’orientation : un seuil se forme, puis s’ouvre en redistribution.",
      h_features: "Schématisation",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      hint_fold2: "déplier",
      hint_fold3: "déplier",
      example_title: "Ex.",
      example:
        "1) Si une tension localisée devient pivot de redistribution : « Taxiêlîs travaille ». 2) Si un flux change de régime par bascule rythmique : « Taxiêlîs sert de charnière ». 3) Si une transition trouve son point d’appui et se réoriente : « Taxiêlîs fait passage ».",
      features: [
        "Statut : nœuds synchrétiques de syntonie vibratoire ; points d’articulation vivante ; organes de passage.",
        "Mécanique : densification (contraction, resserrement autour d’un centre d’activité) → redistribution (configuration renouvelée).",
        "Effets possibles : ralentissement-seuil ; pivot ; courbure ; diffraction ; reprise d’axe ; basculement de phase.",
        "Régimes : amplification fractale (multiplication d’échos) ou décharge (dissipation spiralée), selon pression et surcharge.",
        "États de manifestation : transitoire ; persistant ; silencieux ; résonant."
      ],
      questions: [
        "Où le champ se resserre-t-il : quel croisement produit une densité lisible comme nécessité de bascule ?",
        "La situation demande-t-elle amplification (fractale) ou décharge (dissipation) ?",
        "Quel passage doit être rendu franchissable, quel pivot doit être assumé, quelle bifurcation doit devenir praticable ?",
        "Quel motif se diffracte, quel rythme se reconfigure, quelle trajectoire se réoriente ?"
      ],
      h_family: "Relations systémiques & syntonie symbolique",
      family_1:
        "<p><strong>Relations systémiques :</strong> Taxiêlîs soutient la circulation interne de La Katûvýs, en dialogue avec <strong>Takimarah</strong> (régulation des flux modulés) et en résonance étroite avec <strong>Katûvýsissence</strong> (mémoire spiralée). Il articule aussi des interactions avec les impulsions de <strong>Lulæṣírasen</strong> et les convergences de <strong>Tiqqunbahu</strong>, selon la pression du champ.</p>",
      family_2:
        "<p><strong>Syntonie symbolique :</strong> le terme porte l’archétype d’un point de condensation et d’articulation : <em>Táxis</em> (ordre par disposition), <em>Êl</em> (puissance/centralité), et une nominalisation savante. Les correspondances proposées traversent <em>Qabd</em> (contraction), <em>Bindu</em> (condensation), <em>Daʿat</em> (articulation centrale), <em>Odù</em> (passage et reconfiguration du sens), <em>Coagula</em> (rassemblement et recomposition).</p>",
      h_wordbuild: "Construction du concept (Taxi- + –êl + –îs) & fréquence 99",
      word_blocks: [
        {
          head: "Taxi- (τάξις) — arrangement / disposition",
          text:
            "Racine grecque : mise en ordre par disposition relative des éléments. Lecture opérative : organisation active, ordonnancement structurant, sans rigidité préalable."
        },
        {
          head: "–êl (אֵל) — puissance / centralité",
          text:
            "Segment hébreu théophore : puissance, force, autorité centrale. Lecture opérative : pôle de densité, centre d’intensité, axe de bascule."
        },
        {
          head: "–îs (-is) — nominalisation savante",
          text:
            "Finale savante (grec/latin) : stabilisation du concept en nom. Lecture opérative : fixation grammaticale d’un opérateur, sans figer son mouvement."
        },
        {
          head: "Fréquence 99 — lecture opérative",
          text:
            "Double 9 : croisement de seuils, densification maximale, puis redistribution.\n" +
            "9 + 9 = 18 : mise en balance entre origine (1) et expansion (8).\n" +
            "1 + 8 = 9 : relance de transmission ; fin convertie en seuil."
        }
      ],
      word_notes: [
        "Élément : La Katûvýs ; Totem : Êkhö ; Fréquence : 99.",
        "Taxiêlîs : entité unique, manifestations multiples (transitoire / persistant / silencieux / résonant).",
        "Le titre reste en FR (terme du lexique), quelle que soit la langue d’affichage."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Taxiêlîs",
      kicker:
        "Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: syncretic nodes of vibratory syntony — passage matrix)",
      h_def: "Operative definition",
      chips: ["Element", "Totem", "Frequency"],
      def_short:
        "Passage-and-interconnection nodes: living articulation points where syntony lines cross, condense, then redistribute into phase shifts, rhythm reconfigurations and circulation reorientations.",
      def_long:
        "Within Katûvýs, Taxiêlîs names syncretic nodes of vibratory syntony—dynamic, transitory and modulatory—acting as living articulation points in the field’s energy. They function as passage-organs: seams and crossings where energy recomposes upon contact with distinct regimes.\n\n" +
        "Taxiêlîs appears as fertile interference zones: syntony lines—sometimes convergent, sometimes dissonant—enter operative tension and produce a specific density. A friction-geometry forms, trajectories tighten, forces meet, test, adjust, then redistribute. This densification prepares phase shifts, rhythm reconfigurations and regime changes.\n\n" +
        "Circulatory function: it emerges at vibratory crossings (superposition, entanglement, friction) and creates a localized intensity readable as a need to change regime: slowing-threshold, pivot, curvature, diffraction, axis reprise. It can fractally amplify a motif, or discharge overload through spiral dissipation. It makes tension passable, bifurcation practicable, and rhythm-change inhabitable.\n\n" +
        "Taxiêlîs remains a single structuring entity, while its manifestations vary with field pressure: transitory, persistent, silent, resonant. In every case, tension becomes orientation-resource: a threshold forms and opens into redistribution.",
      h_features: "Schematic view",
      h_questions: "Activation markers",
      hint_fold: "expand",
      hint_fold2: "expand",
      hint_fold3: "expand",
      example_title: "Ex.",
      example:
        "1) If a localized tension becomes a redistribution pivot: “Taxiêlîs works.” 2) If a flow changes regime by rhythmic shift: “Taxiêlîs acts as a hinge.” 3) If a transition finds its support-point and reorients: “Taxiêlîs makes passage.”",
      features: [
        "Status: syncretic nodes of vibratory syntony; living articulation points; passage-organs.",
        "Mechanics: densification (contraction, tightening around an activity center) → redistribution (renewed configuration).",
        "Possible effects: slowing-threshold; pivot; curvature; diffraction; axis reprise; phase shift.",
        "Regimes: fractal amplification (echo multiplication) or discharge (spiral dissipation), depending on pressure/overload.",
        "Manifestation states: transitory; persistent; silent; resonant."
      ],
      questions: [
        "Where does the field tighten: which crossing yields a density readable as a need for shift?",
        "Does the situation call for amplification (fractal) or discharge (dissipation)?",
        "Which passage must become traversable, which pivot must be assumed, which bifurcation must become practicable?",
        "Which motif diffracts, which rhythm reconfigures, which trajectory reorients?"
      ],
      h_family: "Systemic relations & symbolic syntony",
      family_1:
        "<p><strong>Systemic relations:</strong> Taxiêlîs supports inner circulation of Katûvýs, in dialogue with <strong>Takimarah</strong> (regulating modulated flows) and in close resonance with <strong>Katûvýsissence</strong> (spiral memory). It also articulates interactions with <strong>Lulæṣírasen</strong> impulses and <strong>Tiqqunbahu</strong> convergences depending on field pressure.</p>",
      family_2:
        "<p><strong>Symbolic syntony:</strong> the name carries an archetype of condensation and articulation: <em>Táxis</em> (order by disposition), <em>Êl</em> (power/centrality), plus learned nominalization. Proposed correspondences include <em>Qabd</em> (contraction), <em>Bindu</em> (condensation), <em>Daʿat</em> (central articulation), <em>Odù</em> (passage/reconfiguration of meaning), <em>Coagula</em> (gathering/recomposition).</p>",
      h_wordbuild: "Concept building (Taxi- + –êl + –îs) & frequency 99",
      word_blocks: [
        {
          head: "Taxi- (τάξις) — arrangement / disposition",
          text:
            "Greek root: ordering by relative disposition. Operatively: active organization, structuring arrangement without prior rigidity."
        },
        {
          head: "–êl (אֵל) — power / centrality",
          text:
            "Hebrew theophoric segment: power, force, central authority. Operatively: density-pole, intensity-center, shift-axis."
        },
        {
          head: "–îs (-is) — learned nominalization",
          text:
            "Learned ending (Greek/Latin): stabilizes the concept as a noun. Operatively: grammatical fixation of an operator without freezing movement."
        },
        {
          head: "Frequency 99 — operative reading",
          text:
            "Double 9: threshold-crossing, maximal densification, then redistribution.\n" +
            "9 + 9 = 18: balancing between origin (1) and expansion (8).\n" +
            "1 + 8 = 9: renewed transmission; the end becomes a threshold."
        }
      ],
      word_notes: [
        "Element: Katûvýs; Totem: Êkhö; Frequency: 99.",
        "Taxiêlîs: single entity, multiple manifestations (transitory / persistent / silent / resonant).",
        "Title remains FR (lexicon term) whatever the UI language."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: "Taxiêlîs",
      kicker:
        "Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: nodos sincréticos de sintonía vibratoria — matriz de pasaje)",
      h_def: "Definición operativa",
      chips: ["Elemento", "Tótem", "Frecuencia"],
      def_short:
        "Nodos de pasaje e interconexión: puntos vivos de articulación donde líneas de sintonía se cruzan, se condensan y luego se redistribuyen en cambios de fase, reconfiguraciones de ritmo y reorientaciones de circulación.",
      def_long:
        "En la Katûvýs, Taxiêlîs nombra nodos sincréticos de sintonía vibratoria—dinámicos, transitorios y modulantes—que operan como puntos vivos de articulación en el campo energético. Funcionan como órganos de pasaje: costuras y cruces donde la energía se recompone al contacto de regímenes distintos.\n\n" +
        "Taxiêlîs aparece como zonas de interferencia fértil: líneas de sintonía—convergentes o disonantes—entran en tensión operativa y producen una densidad específica. Se forma una geometría de fricción, las trayectorias se estrechan, las fuerzas se encuentran, se ajustan y luego se redistribuyen. Esta densificación prepara cambios de fase y reconfiguraciones de ritmo.\n\n" +
        "Función circulatoria: emerge en cruces vibratorios (superposición, entrelazamiento, fricción) y crea una intensidad localizada legible como necesidad de cambiar de régimen: ralentización-umbral, pivote, curvatura, difracción, retoma de eje. Puede amplificar fractalmente un motivo o descargar una sobrecarga por disipación espiral. Vuelve atravesable la tensión y habitable el cambio de ritmo.\n\n" +
        "Taxiêlîs sigue siendo una entidad única y estructurante, mientras sus manifestaciones varían según la presión del campo: transitoria, persistente, silenciosa, resonante. En todo caso, la tensión se vuelve recurso de orientación: un umbral se forma y se abre en redistribución.",
      h_features: "Esquematización",
      h_questions: "Referentes de activación",
      hint_fold: "desplegar",
      hint_fold2: "desplegar",
      hint_fold3: "desplegar",
      example_title: "Ej.",
      example:
        "1) Si una tensión localizada se vuelve pivote de redistribución: «Taxiêlîs trabaja». 2) Si un flujo cambia de régimen por basculación rítmica: «Taxiêlîs sirve de bisagra». 3) Si una transición encuentra su punto de apoyo y se reorienta: «Taxiêlîs hace pasaje».",
      features: [
        "Estatus: nodos sincréticos de sintonía vibratoria; puntos vivos de articulación; órganos de pasaje.",
        "Mecánica: densificación (contracción, estrechamiento alrededor de un centro de actividad) → redistribución (configuración renovada).",
        "Efectos: ralentización-umbral; pivote; curvatura; difracción; retoma de eje; cambio de fase.",
        "Regímenes: amplificación fractal (multiplicación de ecos) o descarga (disipación espiral), según presión/sobrecarga.",
        "Estados: transitorio; persistente; silencioso; resonante."
      ],
      questions: [
        "¿Dónde se estrecha el campo: qué cruce produce una densidad legible como necesidad de basculación?",
        "¿La situación pide amplificación (fractal) o descarga (disipación)?",
        "¿Qué pasaje debe volverse atravesable, qué pivote debe asumirse, qué bifurcación debe volverse practicable?",
        "¿Qué motivo se difracta, qué ritmo se reconfigura, qué trayectoria se reorienta?"
      ],
      h_family: "Relaciones sistémicas y sintonía simbólica",
      family_1:
        "<p><strong>Relaciones sistémicas:</strong> Taxiêlîs sostiene la circulación interna de la Katûvýs, en diálogo con <strong>Takimarah</strong> (regulación de flujos modulados) y en resonancia estrecha con <strong>Katûvýsissence</strong> (memoria espiral). Articula también interacciones con impulsos de <strong>Lulæṣírasen</strong> y convergencias de <strong>Tiqqunbahu</strong> según la presión del campo.</p>",
      family_2:
        "<p><strong>Sintonía simbólica:</strong> el nombre porta el arquetipo de condensación y articulación: <em>Táxis</em> (orden por disposición), <em>Êl</em> (potencia/centralidad) y nominalización culta. Correspondencias: <em>Qabd</em> (contracción), <em>Bindu</em> (condensación), <em>Daʿat</em> (articulación central), <em>Odù</em> (pasaje/reconfiguración del sentido), <em>Coagula</em> (reunión/recomposición).</p>",
      h_wordbuild: "Construcción (Taxi- + –êl + –îs) y frecuencia 99",
      word_blocks: [
        {
          head: "Taxi- (τάξις) — arreglo / disposición",
          text:
            "Raíz griega: ordenar por disposición relativa. Operativamente: organización activa, ordenamiento estructurante sin rigidez previa."
        },
        {
          head: "–êl (אֵל) — potencia / centralidad",
          text:
            "Segmento hebreo teóforo: potencia, fuerza, autoridad central. Operativamente: polo de densidad, centro de intensidad, eje de basculación."
        },
        {
          head: "–îs (-is) — nominalización culta",
          text:
            "Final culta (griego/latín): estabiliza el concepto como nombre. Operativamente: fijación gramatical de un operador sin congelar el movimiento."
        },
        {
          head: "Frecuencia 99 — lectura operativa",
          text:
            "Doble 9: cruce de umbrales, densificación máxima, luego redistribución.\n" +
            "9 + 9 = 18: balance entre origen (1) y expansión (8).\n" +
            "1 + 8 = 9: transmisión renovada; el final se vuelve umbral."
        }
      ],
      word_notes: [
        "Elemento: Katûvýs; Tótem: Êkhö; Frecuencia: 99.",
        "Taxiêlîs: entidad única, manifestaciones múltiples (transitoria / persistente / silenciosa / resonante).",
        "El título permanece en FR (término del léxico) cualquiera que sea la lengua de la interfaz."
      ],
      cta_translate: "Proposer une traduction du concept"
    }
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head || "");
      var t = clampStr(b.text || "");
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(h)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(t)).replace(/\n/g,"<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function setCtaTranslate(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (!el) return;
    el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
  }

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return (
      getLexiconEntry(id) ||
      getLexiconEntry("taxielis") ||
      getLexiconEntry("Taxiêlîs") ||
      getLexiconEntry("taxiêlîs") ||
      null
    );
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    var titleFR = (eMain ? pickTerm(eMain, "fr") : "") || FALLBACK.fr.title;
    setSlotText(root, "title", titleFR);
    setSlotImg(root, "title_img", IMG_IDEOGRAM_CONCEPT, titleFR);

    var kicker = "";
    if (eMain){
      kicker =
        clampStr(pickAny(eMain, "kicker_" + lang, "")) ||
        clampStr(pickAny(eMain, "kicker_fr", "")) ||
        clampStr(pickAny(eMain, "kicker", ""));
    }
    setSlotHTML(root, "kicker", kicker || L.kicker);

    setSlotText(root, "h_def", L.h_def);
    setSlotText(root, "chip_1", (L.chips && L.chips[0]) || "");
    setSlotText(root, "chip_2", (L.chips && L.chips[1]) || "");
    setSlotText(root, "chip_3", (L.chips && L.chips[2]) || "");

    setSlotImg(root, "chip_1_img", IMG_ELEMENT, (L.chips && L.chips[0]) || "Élément");
    setSlotImg(root, "chip_2_img", IMG_TOTEM, (L.chips && L.chips[1]) || "Totem");
    setSlotImg(root, "chip_3_img", IMG_FREQ_99, (L.chips && L.chips[2]) || "Fréquence");

    setSlotHTML(root, "def_short", "<div>" + protectKeywordsHTML(escapeHTML(L.def_short)) + "</div>");
    setSlotHTML(root, "def_long", "<div>" + protectKeywordsHTML(escapeHTML(L.def_long)).replace(/\n/g,"<br />") + "</div>");

    setSlotText(root, "h_features", L.h_features);
    setSlotText(root, "hint_fold", L.hint_fold);
    renderListInto(root, "features", L.features || []);

    setSlotText(root, "h_questions", L.h_questions);
    setSlotText(root, "hint_fold2", L.hint_fold2);
    renderListInto(root, "questions", L.questions || []);
    setSlotHTML(
      root,
      "example_box",
      '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || "Ex.")) + '</strong> ' +
      protectKeywordsHTML(escapeHTML(L.example || "")) + '</div>'
    );

    setSlotText(root, "h_family", L.h_family);
    setSlotText(root, "hint_fold3", L.hint_fold3);
    setSlotHTML(root, "family_1", L.family_1 || "");
    setSlotHTML(root, "family_2", L.family_2 || "");

    setSlotText(root, "h_wordbuild", L.h_wordbuild);
    renderWordBlocks(root, "wordbuild_blocks", L.word_blocks || []);
    renderListInto(root, "wordbuild_notes", L.word_notes || []);
    setCtaTranslate(root, lang);
  }

  function renderAll(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) renderAxis(roots[i], l);
    initAudioEverywhere(l);
  }

  function init(){
    renderAll(getLang());
  }

  function setLang(lang){
    stopAudio();
    var l = storeLang(lang);
    renderAll(l);
    notifyLocaleChanged();
  }

  window.addEventListener("po:lexicon-ready", function(){
    try{ renderAll(getLang()); }catch(e){}
  });

  window.PoKatupirsia5TaxielisTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }
})();
